const viewSiteContent = {
  storeLocator: {
    findAStore: 'Where To Buy',
    findStoreNearby: 'FIND STORE NEARBY',
    submit: 'SUBMIT',
    enableLocation: 'Enable your location and locate a store near you',
    distance: 'Distance',
    category: 'Category',
    product: 'Product',
    storesFound: 'Stores Found',
    miles: 'miles',
    allProducts: 'All Products',
    productType: 'All Products',
    noStoresFound: 'No Stores Found',
    narrowSearch: 'Narrow Your Search',
    apply: 'APPLY',
    custom: 'CUSTOM',
    customProducts: 'CUSTOMPRODUCTS',
    default: 'DEFAULT',
    full: 'FULL',
    or: 'Or',
    pinError: 'Please enter valid zip code',
    categoryError: 'Please select category',
    productError: 'Please select product',
    locationDisabled: 'Location Disabled',
    locationMessage:
      'Please navigate to browsers settings to enable the location tracking for this website.',
    narrowYourSearch: 'Narrow your search',
    placeholderText: 'Zip/postal code',
    iconFilterTitle: 'Filter',
    iconSearchTitle: 'Search',
    categoryLabel: 'All Vanity Fair\xAE Products',
  },
  bannerCarousel: {
    carouselControlPrevious: 'Previous',
    carouselControlNext: 'Next',
    iconChevronLeftTitle: 'Left',
    iconChevronRightTitle: 'Right',
  },
  featureProduct: {
    iconPlayTitle: 'Play',
  },
  heroBanner: {
    iconPlayTitle: 'Play',
  },
  imageTile: {
    iconPlayTitle: 'Play',
  },
  imageTitle: {
    iconPlayTitle: 'Play',
  },
  productSolution: {
    iconPlayTitle: 'Play',
  },
};

export default viewSiteContent;



// WEBPACK FOOTER //
// ./src/locale/vanity-fair/view-site-content-i18n.js